export const EXTERNAL_LINKS = {
  LEGAL_KITZ: 'https://legalkitz.com.au',
  BIZCOVER:
    'https://insure.bizcover.com.au/OccupationSelection?utm_source=BIZKITZ&utm_medium=Form&utm_campaign=BIZKITZ',
};
